import Opinion from '@/components/Approval/RightContainer/ApprovalContent/Opinion';
import OpinionComment from '@/components/Approval/RightContainer/ApprovalContent/OpinionComment';
import { CommentLayout } from '@/components/Approval/RightContainer/ApprovalContent/TitleInfo/styles';
import React from 'react';
import { ApprovalComment } from '@/types/api';

type P = {
  commentCount: number;
  opinionCount: number;
  lastOpinionBy?: {
    name: string;
    positionName: string;
    opinion: string;
    updatedAt: string;
  };
  latestComment?: ApprovalComment;
};

const CommentAndOpinion = ({
  commentCount,
  opinionCount,
  lastOpinionBy,
  latestComment,
}: P) => {
  const totalCount = commentCount + opinionCount;

  // 최신 의견/코멘트 찾기
  const getLatestText = () => {
    if (!lastOpinionBy && !latestComment) return null;

    // 최신 것 결정
    const useComment =
      latestComment &&
      (!lastOpinionBy ||
        new Date(latestComment.updatedAt) > new Date(lastOpinionBy.updatedAt));

    if (useComment) {
      const { name, positionName } = latestComment.createdBy.detail;
      return `${name} ${positionName} : ${latestComment.content}`;
    } else {
      return `${lastOpinionBy?.name} ${lastOpinionBy?.positionName} : ${lastOpinionBy?.opinion}`;
    }
  };

  const latestText = getLatestText();

  return (
    <CommentLayout>
      {totalCount > 0 && <Opinion opinionCount={totalCount} />}
      {latestText && <OpinionComment opinionComment={latestText} />}
    </CommentLayout>
  );
};
export default CommentAndOpinion;
